import script from "./AccountApplicationActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountApplicationActions.vue?vue&type=script&setup=true&lang=js"

import "./AccountApplicationActions.vue?vue&type=style&index=0&id=2882b90c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2882b90c"]])

export default __exports__